export const settlementPolicyOptions = [
  { value: 'pay_expected_then_settle', label: 'Pay expected, settle on reconcile' },
  { value: 'block_until_reconciled', label: 'Block payout until reconciled' },
];
